var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5013 0.666748C3.28951 0.666748 0.667969 3.28829 0.667969 6.50008C0.667969 9.71187 3.28951 12.3334 6.5013 12.3334C7.95797 12.3334 9.28881 11.7901 10.3132 10.9011L10.668 11.2559V12.3334L15.668 17.3334L17.3346 15.6667L12.3346 10.6667H11.2572L10.9023 10.3119C11.7913 9.28759 12.3346 7.95675 12.3346 6.50008C12.3346 3.28829 9.71309 0.666748 6.5013 0.666748ZM6.5013 2.33341C8.81236 2.33341 10.668 4.18902 10.668 6.50008C10.668 8.81114 8.81236 10.6667 6.5013 10.6667C4.19025 10.6667 2.33464 8.81114 2.33464 6.50008C2.33464 4.18902 4.19025 2.33341 6.5013 2.33341Z",
    fill: "#8A9199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.efedf38e.svg";
export { ForwardRef as ReactComponent };